import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { Create, Add, SyncAlt, Receipt } from '@material-ui/icons';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { wsGetAll } from 'services/WService.js';

import ModalCustomerPortfolioB from './Modal';
import ModalDailyCP from './DailyCustomerPortfolioModal';

import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import { FormControl, IconButton, InputLabel, MenuItem, Select, Tooltip } from '@material-ui/core';
import { wsFindBy } from 'services/WService';
import ButtonDelete from 'hooks/ButtonDelete';
import ExchangeSeller from './ExchangeSeller';
import SetSeller from './SetSeller';
import { WithApp } from 'contexts/appContext';
import { LayerProvider } from 'contexts/layerContext';
import ReplaceSellerModal from './ReplaceSellerModal';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 230 },
  { Header: 'Vendedor', accessor: 'seller', width: 300 },
  { Header: 'DNI Vendedor', accessor: 'sellerDni', width: 130 },
  { Header: 'Mesa', accessor: 'bureau', width: 250 },
  { Header: 'Zona', accessor: 'zone', width: 150 },
  { Header: 'Cartera', accessor: 'customerPortfolio', width: 150 },
  { Header: 'Día de visita', accessor: 'visitDay', width: 200 },
  { Header: 'Ruta', accessor: 'route', width: 300 },
  { Header: 'Frecuencia', accessor: 'frequency' },
  { Header: 'Estado', accessor: 'state', width: 100 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 5 },
];

export default WithApp(function CustomerPortfolioB(props) {
  const classes = useStyles();

  const [open, setOpenExchange] = useState(false);
  const [openSetSeller, setOpenSetSeller] = useState(false);
  const [replaceSellerModel, setReplaceSellerOpen] = useModal();

  const handleClickOpenChange = () => {
    setOpenExchange(true);
  };

  const handleClickOpenSet = () => {
    setOpenSetSeller(true);
  };

  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [customerPortfolioBs, setCustomerPortfolioBs] = useState([]);

  const [showModalDailyCP, setShowModalDailyCP] = useState(false);
  const [customerPB, setCustomerPB] = useState();

  const [zones, setZones] = useState([]);
  const [zoneSelect, setZoneSelect] = useState(0);
  const [sellerId, setSellerId] = useState(null);
  const [customerBureau, setCustomerBureau] = useState(undefined);
  const [dataLoading, setDataLoading] = useState(false);
  

  async function loadCustomerPortfolioBs() {
    let filter = { base_zone_id: zoneSelect };
    if (zoneSelect === 0) delete filter.base_zone_id;
    setDataLoading(true);
    let response = await wsFindBy('base/customer-portfolio-bureau', filter);
    setDataLoading(false);
    if (response.success) setCustomerPortfolioBs(response.data);
  }

  async function listZones() {
    setDataLoading(true);
    let response = await wsGetAll('base/zone');
    setDataLoading(false);
    if (response.success) {
      setZones(response.data);
    }
  }

  useEffect(() => {
    listZones();
    loadCustomerPortfolioBs();
  }, [zoneSelect]);

  return (
    <GridContainer>
      <LayerProvider>
        <Toasty action={notify} />
        {model.open ? (
          <ModalCustomerPortfolioB
            model={model}
            setOpen={setOpen}
            showNotify={showNotify}
            reload={loadCustomerPortfolioBs}
          />
        ) : undefined}

        <ModalDailyCP show={showModalDailyCP} close={setShowModalDailyCP} customerPB={customerPB} />
        <ReplaceSellerModal
          model={replaceSellerModel}
          setOpen={setReplaceSellerOpen}
          showNotify={showNotify}
        />

        <ExchangeSeller
          open={open}
          setOpen={setOpenExchange}
          showNotify={showNotify}
          reload={loadCustomerPortfolioBs}
          sellerId={sellerId}
          customerBureau={customerBureau}
        />

        <SetSeller
          openSetSeller={openSetSeller}
          setOpenSetSeller={setOpenSetSeller}
          showNotify={showNotify}
          reload={loadCustomerPortfolioBs}
        />

        <GridItem xs={12}>
          <Card>
            <CardHeader icon>
              <AllowedGuard
                permission={ConstantPermissions.BASE_CUSTOMER_PORTFOLIO_BUREAUS_STORE}
                component={
                  <CardIcon color="primary">
                    <Receipt style={{ color: 'white' }} />
                  </CardIcon>
                }
              >
                <CardIcon
                  onClick={() => setOpen({})}
                  pointer="true"
                  color={props.themeContext.buttonColorSuccess}
                >
                  <Add />
                </CardIcon>
              </AllowedGuard>
              <h4 className={classes.cardIconTitle}>Listado de Cartera Mesa {dataLoading && <LoadingSpinner />}</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} lg={4}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel>Seleccione zona</InputLabel>
                    <Select
                      defaultValue="0"
                      inputProps={{
                        onChange: (e) => {
                          setZoneSelect(e.target.value);
                        },
                      }}
                    >
                      <MenuItem
                        selected
                        value="0"
                        onChange={() => {
                          setZoneSelect(0);
                          loadCustomerPortfolioBs();
                        }}
                      >
                        Todos
                      </MenuItem>
                      {zones.map((zone, i) => {
                        return (
                          <MenuItem
                            value={zone.id}
                            key={i}
                            onChange={() => {
                              setZoneSelect(zone.id);
                              loadCustomerPortfolioBs();
                            }}
                          >
                            {zone.description}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
                <GridItem xs={12} lg={4} style={{ display: 'flex', alignItems: 'flex-end' }}>
                  <AllowedGuard
                    permission={ConstantPermissions.BASE_CUSTOMER_PORTFOLIO_BUREAUS_SET_SELLER}
                  >
                    <Button
                      color={props.themeContext.buttonColorWarning}
                      onClick={handleClickOpenSet}
                      size="sm"
                    >
                      Asignar vendedor
                    </Button>
                  </AllowedGuard>
                  <AllowedGuard
                    permission={ConstantPermissions.BASE_CUSTOMER_PORTFOLIO_BUREAUS_SET_SELLER}
                  >
                    <Button
                      color={props.themeContext.buttonColorWarning}
                      onClick={() => setReplaceSellerOpen({})}
                      size="sm"
                    >
                      Transferir carteras
                    </Button>
                  </AllowedGuard>
                </GridItem>
              </GridContainer>
              <ReactTable
                excelName="Cartera-mesa"
                defaultWidth={2000}
                columns={columns}
                data={customerPortfolioBs.map((customerPortfolioB, index) => {
                  let frequency = 'Semanal';
                  switch (customerPortfolioB.frequency) {
                    case 'W':
                      frequency = 'Semanal';
                      break;
                    case 'B':
                      frequency = 'Quincenal';
                      break;
                    case 'M':
                      frequency = 'Mensual';
                      break;
                  }
                  return {
                    num: (
                      <div className="actions-right">
                        {index + 1}
                        <AllowedGuard
                          permission={
                            ConstantPermissions.BASE_CUSTOMER_PORTFOLIO_BUREAUS_EXCHANGE_SELLER
                          }
                        >
                          <Tooltip title="Intercambiar cartera">
                            <Button
                              justIcon
                              round
                              simple
                              color="success"
                              className="like"
                              onClick={() => {
                                setSellerId(customerPortfolioB.base_seller_id);
                                setCustomerBureau(customerPortfolioB);
                                handleClickOpenChange();
                              }}
                            >
                              <SyncAlt />
                            </Button>
                          </Tooltip>
                        </AllowedGuard>
                        <AllowedGuard
                          permission={ConstantPermissions.BASE_CUSTOMER_PORTFOLIO_BUREAUS_UPDATE}
                        >
                          <Button
                            justIcon
                            round
                            simple
                            color={props.themeContext.buttonColorWarning}
                            onClick={() => setOpen(customerPortfolioB)}
                          >
                            <Create />
                          </Button>
                        </AllowedGuard>
                        <AllowedGuard
                          permission={
                            ConstantPermissions.BASE_CUSTOMER_PORTFOLIO_BUREAUS_ADD_DAILY_PORTFOLIO
                          }
                        >
                          <Tooltip
                            title="Agregar cartera diaria"
                            onClick={() => {
                              setCustomerPB(customerPortfolioB.id);
                              setShowModalDailyCP(true);
                            }}
                          >
                            <IconButton color="primary" aria-label="Agregar cartera diaria">
                              <Add />
                            </IconButton>
                          </Tooltip>
                        </AllowedGuard>
                        <AllowedGuard
                          permission={ConstantPermissions.BASE_CUSTOMER_PORTFOLIO_BUREAUS_DELETED}
                        >
                          <ButtonDelete
                            entity="base/customer-portfolio-bureau"
                            id={customerPortfolioB.id}
                            reload={loadCustomerPortfolioBs}
                          />
                        </AllowedGuard>
                      </div>
                    ),

                    seller: (customerPortfolioB.SlpCode + ' - ' + customerPortfolioB.SlpName) || 'Sin vendedor',
                    sellerDni: customerPortfolioB.dni || 'Sin dni',
                    bureau: customerPortfolioB.base_bureau_description,
                    zone: customerPortfolioB.base_zone_description,
                    customerPortfolio: customerPortfolioB.base_customer_portfolio_description,
                    visitDay: customerPortfolioB.base_visit_day_description,
                    route: customerPortfolioB.base_route_description,
                    frequency,
                    state: customerPortfolioB.state === 'A' ? 'Activo' : 'Inactivo',
                    actions: '',
                  };
                })}
              />
            </CardBody>
          </Card>
        </GridItem>
      </LayerProvider>
    </GridContainer>
  );
});
